import { FormTextareaField, lt } from '@mews/framework';
import { fieldNames } from './schema';

export const ReasonField = () => (
    <FormTextareaField
        name={fieldNames.reason}
        label={lt('Reason')}
        rows={1}
        placeholder={lt('BillReinstateReasonPlaceholder')}
        required
    />
);
